module.exports = __webpack_public_path__ + "static/media/Vidhi-Mehta.4f91a962.png";